const width = {
    mobileXS: '280px',
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
}

const height ={
    mobileXS: '600px',
    mobileS: '600px',
    mobileM: '700px',
    mobileL: '800px',
}

export const deviceWidth = {
    mobileXS: `(max-width: ${width.mobileXS})`,
    mobileS: `(max-width: ${width.mobileS})`,
    mobileM: `(min-width: ${width.mobileM})`,
    mobileL: `(min-width: ${width.mobileL})`,
};

export const deviceHeight = {
    mobileXS: `(min-height: ${height.mobileXS})`,
    mobileS: `(max-height: ${height.mobileS})`,
    mobileM: `(min-height: ${height.mobileM})`,
    mobileL: `(min-height: ${height.mobileL})`,
};